import React from 'react';

export default function Services() {
  return (
    <section className="services section">
      <h2 className="section__tittle-2 ">
<div style={{ textAlign: "center" }}>
  {/* Trakio — Smarter Tracking. Better Growth. */}
  {/* <br />
  <br /> */}
  Track Smarter. Grow Faster.
</div>
<br />
      </h2>

    </section>
  );
}
